export default "__VITE_ASSET__C85F8Jcp__"